import {PickupPoint} from "./pickup-point";

export class GlsParcelshop extends PickupPoint {

	init() {
		window.addEventListener('message', (message) => {

			if (typeof message.data == 'undefined') {
				return;
			}

			if (message.data.event_id == 'ps_data_handover') {
				this.callback(message.data.parcelshop)
			}
		});
	}

	callback(location) {

		let address = location.detail

		this.set_address({
			'pickup_point_id': address.pclshopid,
			'company_name': address.name,
			'address_line_1': address.address,
			'city': address.city,
			'zip': address.zipcode
		})

		this.close_pickup()
	}

	open_pickup() {
		jQuery(document).trigger('open_modal', ['checkout-gls-parcelshop', '', true])
	}

	close_pickup() {
		jQuery(document).trigger('close_modal')
	}

}
